
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import axios from "axios";
import CommonUtils from "@/common-utils";
import Constants from "@/constants";
import { ProductVO } from "../product/vo/product.vo";
import { DateTime } from "luxon";

@Component
export default class MyProducts extends Vue {
  currentTabIdx = 99;

  products = [] as Array<ProductVO>;
  noticePop = false; // 재입고 알림 안내

  // {0}월 {1}일 자동해제
  textExpireIn(expireDate: string) {
    const date = DateTime.fromSQL(expireDate);
    return this.$t("mypage.t0001", [date.month, date.day]);
  }

  // 최근 본 상품
  getRecentProducts() {
    let recentProducts = CommonUtils.getLocalStorageObject(Constants.RECENT_PRODUCTS);
    if (recentProducts instanceof Array == false) {
      return;
    }
    recentProducts = recentProducts.filter((i: string | number) => {
      try {
        return Number(i);
      } catch (e) {
        return false;
      }
    });

    axios.post("/mypage/recent-products", recentProducts).then((r) => {
      this.products = r.data;

      // 서버와 동기화(서버에 없는 상품 제거)
      const products = [] as Array<number>;
      this.products.forEach((r) => {
        products.push(r.productCd);
      });
      CommonUtils.putLocalStorageObject(Constants.RECENT_PRODUCTS, products);
    });
  }

  // 찜한 상품
  getLikedProducts() {
    axios.get("/mypage/liked-products").then((r) => {
      this.products = r.data;
    });
  }

  // 재입고 알림
  getRestockProducts() {
    axios.get("/mypage/restock-notifications").then((r) => {
      this.products = r.data;
    });
  }

  // 탭 이동
  getProducts(idx: number) {
    if (this.currentTabIdx == idx) {
      return;
    }
    this.noticePop = false;
    this.currentTabIdx = idx;
    this.products = [];

    switch (idx) {
      case 0:
           this.getLikedProducts();
        return;
      case 1:
         this.getRestockProducts();
        return;
      case 2:
         this.getRecentProducts();
        return;
    }
  }

  // 알림 / 알림해제
  btnRestockNotification(product: ProductVO, viewType: string) {
    product.viewType = viewType;
    axios.put("/mypage/restock-notification", product).then(() => {
      if (viewType == "01") {
        // 재신청이면
        const expireDate = DateTime.local().plus({ months: 3 });
        product.expireDate = expireDate.toSQLDate();
      }
    });
  }
  btnZzim(product: ProductVO) {
    CommonUtils.zzimProduct(product).then();
  }
  created() {
    this.getProducts(Number(this.$route.params.tabIdx) || 0);
  }
}
